<script setup lang="ts">
import PageContainer from "~/components/ui/PageContainer.vue";

const sections = [
  { title: "Prose Long Questions", to: "/11th/english/prose/", description: "Conceptual aur thematic long answers for prose units." },
  { title: "Poems Long Questions", to: "/11th/english/poems/", description: "Poems ke interpretation aur explanation-based long answers." },
  { title: "Play Long Questions", to: "/11th/english/play/", description: "The End of the Beginning ke scene, humor aur character-based answers." },
  { title: "Solved Exercise Questions", to: "/11th/english/solved-exercise/", description: "Exercise-driven long and extended answers." },
];

const proseUnits = [
  { title: "Unit 1: Khatam-un-Nabiyeen Hazrat Muhammad", to: "/11th/english/prose/khatam-un-nabiyeen-hazrat-muhammad/" },
  { title: "Unit 2: Responsibility of the Youth in Nation-Building", to: "/11th/english/prose/responsibility-of-the-youth-in-nation-building/" },
  { title: "Unit 4: Team Moon", to: "/11th/english/prose/team-moon/" },
  { title: "Unit 5: Impact of Global Warming on Pakistan", to: "/11th/english/prose/impact-of-global-warming-on-pakistan/" },
  { title: "Unit 7: What You Do is What You Are", to: "/11th/english/prose/what-you-do-is-what-you-are/" },
  { title: "Unit 8: Clean Water", to: "/11th/english/prose/clean-water/" },
  { title: "Unit 10: The Punishment of Shahpesh, the Persian, on Khipil, the Builder", to: "/11th/english/prose/the-punishment-of-shahpesh-the-persian-on-khipil-the-builder/" },
  { title: "Unit 12: The Impact of AI on Society, Human Relationships, and Ethics", to: "/11th/english/prose/the-impact-of-ai-on-society-human-relationships-and-ethics/" },
];

const faqs = [
  {
    question: "What kind of long-question support does this page point to?",
    answer: "Yeh page prose, poems, play aur solved exercise ke long questions tak le jata hai.",
  },
  {
    question: "Why are prose long-answer routes listed separately?",
    answer: "Prose chapters me long questions zyada aate hain, is liye unhen alag dikhaya gaya hai.",
  },
  {
    question: "Can this page help with board-style extended answers?",
    answer: "Haan, is page ke chapters long answers ki tayari me madad karte hain.",
  },
];

usePageSeo({
  title: "11th Class English Long Questions | Chapter Wise LQS Prep",
  description: "11th class English long questions ke liye prose, poems, play aur solved exercise based chapter-wise long-answer routes.",
  keywords: "11th class english long questions, class 11 english lqs, 1st year english long questions, chapter wise long questions english",
  schemaType: "CollectionPage",
  schemaProperties: {
    mainEntity: {
      "@type": "ItemList",
      itemListElement: [...sections, ...proseUnits].map((item, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: item.title,
        url: `https://ustaad.today${item.to}`,
      })),
    },
  },
  faqs,
  breadcrumbs: [
    { name: "Home", item: "/" },
    { name: "11th English", item: "/11th/english/" },
    { name: "Long Questions", item: "/11th/english/long-questions/" },
  ],
});
</script>

<template>
  <PageContainer>
    <EnglishHero
      headline="Long Question Revision"
      title="11th Class English Long Questions"
      description="Yahan se aap long questions ki tayari ke liye zaroori sections aur chapters khol sakte hain."
    />

    <EnglishSection
      title="Long-Question Routes"
      description="Jis type ke long questions chahiye, woh section choose karein."
    >
      <EnglishGrid>
        <EnglishCard
          v-for="section in sections"
          :key="section.to"
          :title="section.title"
          :description="section.description"
          :to="section.to"
        />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection
      title="Prose Long-Answer Routes"
      description="Prose ke ye chapters long questions ke liye zyada aham hain."
    >
      <EnglishGrid>
        <EnglishCard
          v-for="unit in proseUnits"
          :key="unit.to"
          :title="unit.title"
          description="Is chapter ke long questions aur important themes dekhain."
          :to="unit.to"
        />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection
      title="FAQs"
      description="Long questions ke bare me aam sawalon ke jawab."
    >
      <EnglishGrid>
        <EnglishCard
          v-for="item in faqs"
          :key="item.question"
          :title="item.question"
          :description="item.answer"
        />
      </EnglishGrid>
    </EnglishSection>
  </PageContainer>
</template>
